// 备用地址（IP 直连 / HTTP，未启用 HTTPS 时使用）
// const baseUrl = 'http://8.159.136.63:9538'
const baseUrl = 'https://hxxapi.dpozhi.cn'

const api = {
    baseUrl: baseUrl
}

export default api
